<template>
	<c-q-btn
		v-if="authStore.currentUserCanViewInstitutional"
		id="btn-view-institutional"
		propBtnLabel="Visualizar"
		:propBtnFunction="onViewInstitutional"
		:propBtnTransparent="true"
		:propBtnSize="props.propBtnSize"
	/>
</template>

<script setup lang="ts">
import { EnumButtonSizes, EnumRouteNames }	from '@/enums/enums';
import { useRouter }						from 'vue-router';
import { useInstitutionalStore } 			from '@/stores/institutionalStore';
import { useAuthStore }						from '@/stores/authStore';
import { usePagesUtilStore }                from '@/stores/pagesUtilStore';

const router = useRouter();
const authStore		= useAuthStore();
const pagesUtilStore  = usePagesUtilStore();
const institutionalStore = useInstitutionalStore();


const props = defineProps({
  propBtnSize: {
    type: String as () => keyof typeof EnumButtonSizes,
    required: false,
    default: EnumButtonSizes.LARGE_1
  },
  id: {
    type: Number,
    required: true
  }
});


const onViewInstitutional = () => {
  router.push({
    name: EnumRouteNames.INSTITUTIONAL_VIEW,
    params: { id: props.id }
  });
};

</script>

<style scoped>

</style>
